// @flow

import type { IncomingPayment, PersonType } from './types';

export function getPersonType(incomingPayment: IncomingPayment): ?PersonType {
  return incomingPayment['person_type'];
}
